import { ProfileNavbar } from "../components/profile/ProfileNavbar";
import { ProfileHero } from "../components/profile/ProfileHero";
import { EngagementSection } from "../components/profile/EngagementSection";
import { SkillsSection } from "../components/profile/SkillsSection";
import { CertificationsSection } from "../components/profile/CertificationsSection";
import { TestimonialsSection } from "../components/TestimonialsSection";
import { ProjectsSection } from "../components/ProjectsSection";
import { ContactSection } from "../components/ContactSection";
import { SiteFooter } from "../components/SiteFooter";
import { SEO } from "../components/SEO";

const FOOTER_LINKS = [
  { label: "How to hire me", section: "engagement" },
  { label: "What I am proud of", section: "projects" },
  { label: "Capabilities", section: "skills" },
  { label: "Contact", section: "contact" },
];

export function ProfilePage() {
  const scrollToSection = (sectionId: string) =>
    document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <div className="relative w-full bg-[#e7f1f1] overflow-x-hidden">
      <SEO
        variant="profile"
        title="Olga Molina — Product designer & full-stack developer for hire"
        description="Freelance and interim product design and full-stack development, specialised in security, GDPR/AVG and WCAG accessibility. Based in the Netherlands, available across Europe."
        url="https://www.geekcow.com/olga"
      />
      <ProfileNavbar />

      <main>
        <div id="landing">
          <ProfileHero />
        </div>
        <div id="projects">
          <ProjectsSection />
        </div>
        <div id="skills">
          <SkillsSection />
          <CertificationsSection />
        </div>
        <div id="engagement">
          <EngagementSection />
        </div>
        
        {/* Capabilities and the badge wall are one block: the claims, then the
            proof a hiring manager can click. Both live under #skills so the
            "Capabilities" nav link lands on the pair. */}
        
        <div id="testimonials">
          <TestimonialsSection />
        </div>
        <div id="contact">
          <ContactSection
            showFooter={false}
            intro={
              <>
                <span className="text-[#141414]">I am </span>
                <span className="text-[#f42536]">ready </span>
                <span className="text-[#141414]">and </span>
                <span className="text-[#256af4]">excited </span>
                <span className="text-[#141414]">to </span>
                <span className="text-[#22c365]">join your team.</span>
              </>
            }
            note="Fill out the form — I'll beam back within a day."
            // Hiring-shaped questions, not project scope + € budget: how they want
            // to work with Olga, and when they need someone.
            scopeQuestion={<>How do you want <span className="text-[#22c365]">to work together?</span></>}
            scopeLabel="Engagement"
            scopeOptions={[
              { label: "In-house", color: "#22c365" },
              { label: "Interim", color: "#256af4" },
              { label: "Project", color: "#f42536" },
              { label: "Advisory", color: "#ffc803" },
            ]}
            budgetQuestion={<>When do you <span style={{ color: "#ffc803" }}>need someone?</span></>}
            budgetLabel="Timeline"
            budgetOptions={["ASAP", "Within a month", "Next quarter", "Just exploring"]}
          />
        </div>
      </main>

      <SiteFooter
        face="profile"
        blurb="Olga Molina — product designer and full-stack developer, specialised in security and compliance. Freelance and interim, from the Netherlands."
        navLinks={FOOTER_LINKS}
        onSectionClick={scrollToSection}
      />
    </div>
  );
}
